<svelte:options

  customElement = {{
    shadow: "none",
    /*                                                                        */
    /*                                  */
    tag: "ofc-sponsored-sheet-v1",
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";
  import type { SponsoredSheetV1Data } from "./index.js";
  import { SPONSORED_SHEET_ID, SPONSORED_SHEET_TAG } from "./consts.js";

  let data = $state<SponsoredSheetV1Data | null>(null);

  function isSponsoredSheetData(value: unknown): value is SponsoredSheetV1Data {
    if (value === null || typeof value !== "object") return false;

    const { advertiserLegalName, funderLegalName } = value as Partial<SponsoredSheetV1Data>;
    return typeof advertiserLegalName === "string" && typeof funderLegalName === "string";
  }

  function handleSheetBeforeOpen(event: CustomEvent) {
    const extraData = event.detail.extraData;
    data = isSponsoredSheetData(extraData) ? extraData : null;
  }

  function handleSheetAfterClose() {
    data = null;
  }

  /*                                                                        */
  /*                                                           */
  /*                                                                         */
  /*                                                                          */
  /*                                                                       */
  /*                                                                         */
  /*                                    */
  onMount(() => {
    const host = $host();
    if (document.querySelector(SPONSORED_SHEET_TAG) !== host) host.remove();
  });
</script>

<oc-sheet-v1
  id={SPONSORED_SHEET_ID}
  headline="Warum sehe ich diese Fläche?"
  data-tr-v1=""
  data-tr-v1-oc-open={'{ "san_ListLayer": ["sponsored product"] }'}
  onoc-sheet-before-open={handleSheetBeforeOpen}
  onoc-sheet-after-close={handleSheetAfterClose}
>
  <p class="oc-copy-100">
    Hier handelt es sich um eine gesponserte Fläche. Das sind Werbeanzeigen, die von unseren Lieferanten und
    Händlern finanziert werden.
  </p>
  <p class="oc-copy-100">Wir achten darauf, dass diese Anzeigen zu deinem Interesse bzw. deiner Suche passen.</p>
  {#if data}
    <h2 class="oc-headline-100 oc-mt-150 oc-mb-50">Über den Werbetreibenden</h2>
    <ul class="oc-list--unordered">
      <li class="oc-mb-25">
        <span class="oc-headline-50">Name des Werbetreibenden:</span>
        {data.advertiserLegalName}
      </li>
      <li>
        <span class="oc-headline-50">Wer hat für diese Anzeige bezahlt:</span>
        {data.funderLegalName}
      </li>
    </ul>
  {/if}
</oc-sheet-v1>
